import Firebase from "./config";
import FirebaseContext from "./context";

export default Firebase;

export { FirebaseContext };
